import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import Sidebar from "src/components/common/Sidebar";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, replaceNbsp } from "src/_config";
import parse from "html-react-parser";
import {
  useAppPerformanceListSelector,
  useAppRodeoEventSettingsSelector,
} from "src/_common/hooks/selectors/eventSelector";
import Sponsor from "src/components/common/Sponsor";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PrizeDetailsPage() {
  const { type, eventId, performanceId } = useParams<any>();
  const eventApi = useEventApi();
  const toast = useToaster();
  const history = useHistory();
  const [prizes, setPrizes] = useState<any>();
  const rodeoEventSettings = useAppRodeoEventSettingsSelector();
  const performanceList = useAppPerformanceListSelector();

  const goToPrizesListPage = () => {
    history.push(`/prizes/${eventId}`);
  };

  const gotoEventPage = () => {
    history.push(`/event/${eventId}/${performanceId}`);
  };

  const getPrizeDetails = () => {
    let params = {
      type: cryptr.decrypt(type).toLowerCase(),
      game_id: cryptr.decrypt(eventId),
    };
    eventApi.callPrizeDetails(
      params,
      (message: any, resp: any) => {
        //console.log({resp})
        setPrizes(resp.prizes);
      },
      (message: any) => {
        toast.error(message);
      }
    );
  };

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (type && eventId) {
      getPrizeDetails();
    }
  }, [type, eventId]);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
          <div className="team-list-title">
            <h1>{performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.title}</h1>
          </div>
          <div className="team-list-date">
            <p>
              {performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate
                ? moment(performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate).format(
                    "MMM DD, YYYY"
                  )
                : ""}
            </p>
          </div>
        </div>
        <div className="pt-3">
          <h3 className="section-heading mb-3">{cryptr.decrypt(type)} Prize</h3>
        </div>

        <div className="prizes-wrap">
          {prizes?.length ? (
            prizes.map((p: any) => (
              <div className="score-range-wrap back_sec" key={p.id}>
                <div className="contestants-wrap leaderboard-title">
                  <div className="contestants-title w-100">
                    {/* <h4>{p?.rodeo_event_dtls?.title}</h4> */}
                    <h4>
                      {cryptr.decrypt(type) == "Game"
                        ? p?.rodeo_event_dtls?.title
                        : p?.rodeo_event_event_id == -1
                        ? "All Events"
                        : p?.rodeo_event_event_dtls?.event_name}
                    </h4>
                  </div>
                </div>
                <ul className="performence-list cons-list-new m-0 p-0">
                  <li className="selected">{parse(replaceNbsp(p.content))}</li>
                </ul>
              </div>
            ))
          ) : (
            <ul className="performence-list cons-list-new m-0 p-0 text-white">No prize added yet</ul>
          )}
        </div>

        {rodeoEventSettings?.is_game_prize &&
          !rodeoEventSettings?.is_event_prize &&
          !rodeoEventSettings?.is_performance_prize && (
            <div className="join-now-btn-wrap">
              <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={gotoEventPage}>
                Play Now
              </button>
            </div>
          )}
      </div>

      <Sponsor />
    </React.Fragment>
  );
}
